/**
 * @ComponentFor Avensia.Scope.ServerRenderedHtmlBlock
 */
import * as React from 'react';
import LinksContainer from './LinksContainer';
import * as inlineScripts from './inline-scripts';

export default class ServerRenderedHtmlBlock<T> extends React.Component<Scope.ServerRenderedHtmlBlock & T, void> {
  element: HTMLDivElement | undefined;
  scriptTagsToBeEvaluated: Array<{
    firstRun: boolean;
    domElement: HTMLElement;
    script: string;
  }> = [];

  componentDidMount() {
    if (this.element) {
      this.element.querySelectorAll('script').forEach(el => {
        const script = {
          domElement: el,
          script: el.innerHTML,
          firstRun: false,
        };
        this.scriptTagsToBeEvaluated.push(script);
        inlineScripts.addScript(script);
      });
    }
  }

  componentWillUnmount() {
    this.scriptTagsToBeEvaluated.forEach(script => inlineScripts.removeScript(script));
  }

  render() {
    return (
      <LinksContainer>
        <div
          ref={e => (this.element = e as HTMLDivElement)}
          dangerouslySetInnerHTML={{ __html: this.props.htmlString }}
        />
      </LinksContainer>
    );
  }
}
